var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLgvLabelCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4102_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6281 11.2344C17.125 11.2344 12.6406 15.7187 12.6406 21.2218C12.6406 26.7249 17.125 31.2093 22.6281 31.2093C28.1312 31.2093 32.6155 26.7249 32.6155 21.2218C32.6155 15.7187 28.1312 11.2344 22.6281 11.2344ZM21.879 17.2269C21.879 16.8174 22.2186 16.4778 22.6281 16.4778C23.0376 16.4778 23.3771 16.8174 23.3771 17.2269V22.2206C23.3771 22.6301 23.0376 22.9696 22.6281 22.9696C22.2186 22.9696 21.879 22.6301 21.879 22.2206V17.2269ZM23.5469 25.5963C23.497 25.7262 23.4271 25.8261 23.3372 25.9259C23.2373 26.0158 23.1275 26.0857 23.0076 26.1357C22.8878 26.1856 22.7579 26.2156 22.6281 26.2156C22.4982 26.2156 22.3684 26.1856 22.2486 26.1357C22.1287 26.0857 22.0188 26.0158 21.919 25.9259C21.8291 25.8261 21.7592 25.7262 21.7092 25.5963C21.6593 25.4765 21.6293 25.3467 21.6293 25.2168C21.6293 25.087 21.6593 24.9571 21.7092 24.8373C21.7592 24.7174 21.8291 24.6076 21.919 24.5077C22.0188 24.4178 22.1287 24.3479 22.2486 24.298C22.4883 24.1981 22.7679 24.1981 23.0076 24.298C23.1275 24.3479 23.2373 24.4178 23.3372 24.5077C23.4271 24.6076 23.497 24.7174 23.5469 24.8373C23.5969 24.9571 23.6268 25.087 23.6268 25.2168C23.6268 25.3467 23.5969 25.4765 23.5469 25.5963Z",
    fill: "#BF2E3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4102_2728",
    x: -4.76567,
    y: -1.03649,
    width: 54.7882,
    height: 54.7882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.13641
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.70461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.180392 0 0 0 0 0.227451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4102_2728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4102_2728",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgvLabelCross);
export default __webpack_public_path__ + "static/media/lgvLabelCross.4e507f0e8aa1b12ddc7ac8143bf3d5fe.svg";
export { ForwardRef as ReactComponent };